import {Image, Radio, Rate} from 'antd';
import React, {RefObject} from "react";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import SignatureCanvas from 'react-signature-canvas'
import IconBuilder from "../../../../../../utils/IconBuilder";
import Utils from "../../../../../../utils";
import FilesService from "../../../../../../model/service/file/FilesService";
import {IAppState} from "../../../../../../redux/store";
import selectors from "../../../../../../redux/selectors";
import {connect} from "react-redux";

interface IProps {
    value?: number,
    onChange?: (value?: number) => void
    options: IFieldOptions
    getText: (code: string, fallBack?: string) => string
}

interface IState {
    value?: number
}

class FormFieldRate extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: props.value
        }
    }

    ref: RefObject<SignatureCanvas> = React.createRef<SignatureCanvas>()

    handleChange = (value?: number) => {
        this.setState({value}, this.updateParent)
    }

    updateParent() {
        this.props.onChange && this.props.onChange(this.state.value)
    }

    render() {
        const {
            rateLength,
            rateIcon,
            disabled,
            showClear,
            rateType,
            rateTexts,
            rateImageHeight,
            rateImages
        } = this.props.options
        const {value, getText} = this.props

        return (
            <div>
                {rateType && {
                    icon: <Rate value={value} count={rateLength}
                                character={rateIcon ? IconBuilder(rateIcon) : undefined}
                                disabled={disabled} allowClear={showClear} onChange={this.handleChange}/>,
                    image: <Radio.Group disabled={disabled} onChange={(e) => this.handleChange(e.target.value)}>
                        {rateImages?.map((val, i) => val && (
                            <Radio className={'d-inline-flex align-items-center'} key={i} value={i + 1}>
                                <Image
                                    src={FilesService.buildThumbnailUrl(val, (rateImageHeight || 50) * 2, rateImageHeight || 50)}
                                    preview={false} fallback={Utils.imageFallback()}/>
                            </Radio>
                        ))}
                    </Radio.Group>,
                    text: <Radio.Group disabled={disabled} onChange={(e) => this.handleChange(e.target.value)}>
                        {rateTexts?.map((val, i) => (
                            <Radio className={'d-inline-flex align-items-center'} key={i} value={i + 1}>
                                <div dangerouslySetInnerHTML={{__html: getText(val)}}/>
                            </Radio>
                        ))}
                    </Radio.Group>,
                }[rateType]}
            </div>
        )
    }
}
const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    };
};

export default connect(mapStateToProps)(FormFieldRate);